import styles from '../../styles/styles.module.css';
import IssueBanner from '../../main_components/issue_banner'
import SubHeading from '../../main_components/sub_heading'
import { useEffect, useState } from "react";
import { Link } from 'react-router-dom';


export const ShowMain = (props) => {
  const title = "";
  useEffect(() => {
    props.setTitle(title)
  }, []);
  const expandHideArticleList = () => {
    setArticleListExpanded(!articleListExpanded)
  }

  const [articleListExpanded, setArticleListExpanded] = useState(false)

  return (
    <>
      <h2 className={styles.title}>
        <SubHeading text="RSA key for any communication" />
      </h2>
      <div className={styles.centered_container}>
        <div className={styles.code_background_rsa}>
          <h2>{keys}</h2>
        </div>
      </div>
      <div className={styles.centered_container}>
        <div className={styles.code_background_rsa}>
          <h2>{email}</h2>
        </div>
      </div>
      <div className={styles.title}>
        <h6>
          <div className={styles.expand_link} onClick={expandHideArticleList}>
            Articles {articleListExpanded ? '↑' : '↓'}
          </div>
          {articleListExpanded && <div>
            <Link to="/interpreter/parser">How do parsers work?</Link>
            <br></br>
            <br></br>

            <Link to="/Assembly/instruction-set">Instruction Set</Link>
            <br></br>
            <br></br>

            <Link to="/NandToTetris/cpu">Implementing a CPU</Link>
            <br></br>
            <br></br>

            <Link to="/NandToTetris/ram16k">RAM from scrach</Link>
            <br></br>
            <br></br>

            <Link to="/NandToTetris/computer">Assembling computer with previous components</Link>
            <br></br>
            <br></br>

            <Link to="/Assembly/winDbg-intel-manual">Getting started with winDbg and intel manual</Link>
            <br></br>
            <br></br>

            <Link to="/rust/four">Chat Server in Rust(tokio)</Link>
            <br></br>
            <br></br>

            <Link to="/rust/six">Making GUI application with ICED in Rust</Link>
            <br></br>
            <br></br>

            <Link to="/cpp/ecs">ECS Design Pattern</Link>
            <br></br>
            <br></br>

            <Link to="/cpp/collision-detection-and-resolution">Collision Detection in Games</Link>
            <br></br>
            <br></br>

            <Link to="/articles/concurrency-in-action">Lessons learnt from "C++ Concurrency in Action"</Link>
            <br></br>
            <br></br>

            <Link to="/graph/one">Path between two vertices</Link>
            <br></br>
            <br></br>

            <Link to="/graph/two">Number of connected components in a Graph</Link>
            <br></br>
            <br></br>

            <Link to="/graph/compute-scc-dg">Compute SCC of a Directed Graph</Link>
            <br></br>
            <br></br>

            <Link to="/database/b+tree-and-dbms">B+Tree and its use in DBMS</Link>
            <br></br>
            <br></br>
          </div>}
        </h6>
      </div>
    </>

  );
}

const keys =
  `-----BEGIN PUBLIC KEY-----
  MIICIjANBgkqhkiG9w0BAQEFAAOCAg8AMIICCgKCAgEA79XVzntVZQZwG9ZahUt5
  TeYv0B5pY0S8L7pugWNayj5Zocx0aHX95jGS4by0WUBTAW4KciwikSWkBDJvbrb1
  PXHUnc6CLmpQf6BmtFrxBVkgR5y1VOmmfQv0ENRIgUW4ybSUIqWucnkkjD6SklMz
  C2Dujd63nhyu+ZiYeCxyL9iJJ+M8QdALKmnyQzUk0IS3fk3WHxSHF456nh5IzyOe
  xEol3in6wXsrhO7XW5Y8U7mqVd7nLChVprbemDlCQ79yynnfTOCoKCa+j3wE/40I
  JsgzdaTH2SsWpflt3RdWezoD86CUGGpRDLJ8rT+u61CM0fRW5IL6Znyrl6PXLyU1
  NwluuIf7/aF94oarzuk8xPWknFut1dbHy754iirj3EVX+Zpxsd7niaH75JIlMRZ2
  n6DlvE+ICTuBjz8Z0jekcFD8x7yZN0LUXmDR0MCLjO335OlGWFtLemDqh1CnRdWp
  +eWmVhHCS6QOOyKoholYjnG5EGvXP73KA4FXkeL6rVphK26jqd4j1QU1ckSvzPmw
  xfyr0HrKlJPbZ27s7mS0jCa3r/7vbihS22niSf3CRKE0y1RthPSW6Ew14L+y4B1R
  4v60rFm6mBTEeS5vJpPkM1Ux80iq11TNwZGKJwrxs0gTbFyI93Cfkahsze3FBbis
  lrHEaE5NT3CxFERsYVRReukCAwEAAQ==
  -----END PUBLIC KEY-----  
`;

const email = `0x616b616@proton.me`